<div class="ticker" *ngIf="(show|async) && (next_cron_import_diff|async) && cfg.domainconfig.import_enabled" style="cursor: help">
    <span *ngIf="!(cron_import_enabled|async)" matTooltip="Automatischer Abschluss deaktiviert">
      <svg-icon>warning</svg-icon>
    </span>
    <span *ngIf="!(cron_import_enabled|async)" matTooltip="Manueller Importabschluss sollte bis {{next_cron_import_run|async}} gemacht werden">{{next_cron_import_diff|async}}</span>
  <span *ngIf="(cron_import_enabled|async)" matTooltip="Nächster automatischer Importabschluss {{next_cron_import_run|async}}">{{next_cron_import_diff|async}}</span>
</div>
